import { z } from 'zod';
export const peerDisplayNameValidator = z
    .string()
    .max(20);
export const peerIdValidator = z
    .string()
    .uuid();
export const peerValidator = z.record(peerIdValidator, peerDisplayNameValidator);
